import React from 'react'
import { NepaliNumber } from 'src/helpers/NepaliNumber'
import { AdalatAPI } from './AdalatAPI'
import { CONSTANTS } from '.././../../constants'

export const AdalatTableContent = {
  getTableHeadings: function () {
    return [
      {
        title: 'सि.नं.',
        field: 'id',
        render: (rowData) => NepaliNumber(rowData.tableData.id + 1),
      },
      {
        title: 'अदालतको नाम',
        field: 'name',
      },

      {
        title: 'अदालत को ठेगाना',
        field: 'address',
      },
    ]
  },

  getTableDatas: function (adalates) {
    return adalates
  },

  getDataActions: function (handleEditOpen, handleDeleteOpen) {
    return [
      {
        icon: 'edit',
        iconProps: {
          style: {
            color: CONSTANTS.EDIT_ICON_COLOR,
            background: CONSTANTS.EDIT_BACKGROUND_COLOUR,
          },
        },
        tooltip: 'Edit',
        onClick: (e, rowData) => handleEditOpen(rowData.id),
        position: 'row',
      },

      {
        icon: 'delete',
        iconProps: {
          style: {
            color: CONSTANTS.DELETE_ICON_COLOR,
            background: CONSTANTS.DELETE_BACKGROUND_COLOR,
          },
        },
        tooltip: 'Delete',
        onClick: (e, rowData) => handleDeleteOpen(rowData.id),
        position: 'row',
      },
    ]
  },
}
